import { initialize } from '@execonline-inc/links.private';
import { Rel } from '../Resource/Types';
import { type Endpoint } from '../Resourceable';

export default initialize<Rel, Endpoint>();
